import CheckboxIconIcon from '@/assets/icons/checkbox-icon.svg?react';
import CheckboxCheckedIconIcon from '@/assets/icons/checkbox-checked-icon.svg?react';

export const MuiCheckboxStyles = {
    styleOverrides: {
        root: {
            '& svg': {
                width: '20px !important',
                height: '20px !important',
            },
        },
    },
    defaultProps: {
        icon: <CheckboxIconIcon />,
        checkedIcon: <CheckboxCheckedIconIcon />,
    },
};
